import { render, staticRenderFns } from "./DetectionListUrlLayout.vue?vue&type=template&id=4a5bab8f&scoped=true"
import script from "./DetectionListUrlLayout.vue?vue&type=script&lang=js"
export * from "./DetectionListUrlLayout.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a5bab8f",
  null
  
)

export default component.exports